module.exports = __webpack_public_path__ + "static/elevate-solar-1ef2ce85f40cc732f23bdcc7421cb7dc.png";